export const removeTime = (date = new Date()) => {
    return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
};

export const statcastDate = (date = new Date()) => {
    return date.toISOString().substring(0,10);
};